import { define, html } from "hybrids";

export interface VBroadcastLayout {
  sponsors: boolean;
  dialog: boolean;
}

export default define<VBroadcastLayout>({
  tag: "v-broadcast-layout",
  sponsors: false,
  dialog: false,
  render: ({ sponsors }) => html`
    <div id="container" class="${{ sponsors }}">
      <section id="dialog"><slot name="dialog"></slot></section>

      <nav id="nav"><slot name="nav"></slot></nav>

      <section id="player" class="rounded"><slot name="player"></slot></section>
        
      <section id="title">
        <slot name="title"></slot>
      </section>
      
      <section id="sponsors">
        <slot name="sponsors"></slot>
      </section>

      <section id="main" class="rounded"><slot></slot></section>
    </div>
  `.css`
    :host {
      display: flex;
      flex: 1 0 auto;
      --v-broadcast-layout-spacing: 16px;
    }

    #container {
      flex: 1 1 auto;
      position: relative;
      display: grid;
      grid-template-rows: auto min-content min-content auto auto;
    }

    #dialog {
      display: none;
      background: rgba(0,0,0,0.4);
      margin: calc(2* var(--v-ui-layout-spacing)) var(--v-ui-layout-spacing) 0;
      padding: calc(2 * var(--v-ui-layout-spacing));
      border-radius: 14px;
      overflow: hidden;
      -webkit-mask-image: -webkit-radial-gradient(white, black);
      justify-self: center;
    }

    :host([dialog]) #dialog {
      display: block;
    }

    :host([dialog]) #player, :host([dialog]) #main {
      display: none;
    }

    #nav {
      display: none;
    }

    #player {
      z-index: 1;
      grid-row: 1 / 2;
      position: relative;
      padding-top: 56.25%;
      background: black;
      overflow: hidden;
      top: 0;
    }

    #player ::slotted(*) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    
    #title {
      grid-row: 3 / 4;
      display: flex;
      justify-content: space-between;
    }
    
    #title ::slotted(*) {
      margin: 10px;
    }
    
    #sponsors {
      grid-row: 4 / 5;
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    #sponsors ::slotted(*) {
      margin: 8px;
    }

    #main {
      grid-row: 5 / 6;
      display: flex;
      flex-flow: column;
      background: rgba(0,0,0,0.4);
    }

    @media (max-aspect-ratio: 3/4) {
      #player {
        position: sticky;
      }

      #player {
        will-change: transform;
      }
    }

    @media (max-width: 930px) {
      #container:not(.sponsors) #sponsors {
        display: none;
      }
      
      #title {
        flex-direction: column;
        background: rgba(0, 0, 0, 0.4);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }
      
      #title ::slotted(v-ui-flexbox) {
        margin-top: 10px;
      }
      
      #container:not(.sponsors) #main {
        grid-row: 4 / 6;
      }
    }

    @media (min-width: 931px) {
      :host {
        max-height: 100%;
      }

      #container {
        max-width: calc(100vh * 1.75);
        margin: 0 auto;
        grid-template-rows: repeat(3, min-content) 1fr;
        grid-template-columns: auto 354px;
        column-gap: 16px;
        padding: 0 16px;
      }

      #dialog {
        width: 370px;
        grid-column: 1 / 3;
        padding: calc(3 * var(--v-ui-layout-spacing)) calc(6 * var(--v-ui-layout-spacing));
      }

      #nav {
        display: grid;
        grid-auto-flow: column;
        grid-gap: var(--v-broadcast-layout-spacing);
        justify-content: flex-end;
        grid-row: 1/2;
        grid-column: 2/3;
      }

      .rounded {
        border-radius: 14px;
        overflow: hidden;
        -webkit-mask-image: -webkit-radial-gradient(white, black);
      }

      #player {
        position: relative;
        align-self: flex-start;
        top: auto;
        grid-row: 1/3;
        grid-column: 1/2;
      }
      
      #title {
        flex-direction: row;
        grid-column: 1/2;
        align-items: center;
      }
      
      #sponsors {
        grid-row: 4/5;
        grid-column: 1/2;
        align-self: flex-start;
        border-bottom: none;
      }

      #sponsors ::slotted(*) {
        margin: 16px;
      }

      #main {
        box-sizing: border-box;
        grid-row: 1/6;
        grid-column: 2/3;
        display: grid;
        grid: 1fr auto / auto;
        padding: 0;
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
        border-bottom: 0px;
        min-height: 0;
      }
    }
  `,
});
